import React from "react";
import RotatingIcons from "../signup/rotating-icons";

const LoginPageLayout = ({ formSectionContent, featuresSectionContent }) => {
    if (!featuresSectionContent) {
        featuresSectionContent = <RotatingIcons />;
    }

    return (
        <div id="login" className="container row auth-form-container">
            <section className="signup-styles padded-column columns five">
                <h2 className="font-xlarge margin-b-l">Log In</h2>
                {formSectionContent}
            </section>
            <section className="columns five offset-two">
                {featuresSectionContent}
            </section>
        </div>
    );
};

export default LoginPageLayout;
